import { isMobile } from 'react-device-detect';

// The Android shell replaces the user agent with its own block (`shellUserAgent` in MainActivity.kt),
// which `react-device-detect` cannot read: a coarse pointer without hover tells the truth everywhere.
const COARSE_POINTER_QUERY = '(hover: none) and (pointer: coarse)';

// The breakpoint `assets/less` lays the trees list beside the map from
const DESKTOP_LAYOUT_QUERY = '(min-width: 992px)';

/**
 * Whether this is a mobile device, in the app as well as in a mobile browser. One answer for both, so the
 * camera layout, the map filters and the tree table cannot disagree about the device.
 */
export function isMobileDevice(): boolean {
  const coarsePointer = typeof window !== 'undefined' && typeof window.matchMedia === 'function'
    && window.matchMedia(COARSE_POINTER_QUERY).matches;

  return isMobile || coarsePointer;
}

/**
 * Whether the page is laid out as on a desktop with trees list beside the map:
 * a tablet is wide enough for it, and this is read from the viewport so it switches at the very same 992px as the CSS
 */
export function isDesktopLayout(): boolean {
  return typeof window !== 'undefined' && typeof window.matchMedia === 'function'
    && window.matchMedia(DESKTOP_LAYOUT_QUERY).matches;
}
